import { useMemo } from "react";
import DefaultPrimaryMetric from "../components/metrics/DefaultPrimaryMetric";
import DefaultSecondaryMetric from "../components/metrics/DefaultSecondaryMetric";
import { MetricComponentProps } from "../types/metrics";
import { useMode } from "./ModeContext";
import { modes } from "./modes";

export function useModeMetrics(): {
  Primary: React.ComponentType<MetricComponentProps>;
  Secondary: React.ComponentType<MetricComponentProps>;
} {
  const { mode } = useMode();

  return useMemo(() => {
    if (!mode) {
      return {
        Primary: DefaultPrimaryMetric,
        Secondary: DefaultSecondaryMetric,
      };
    }
    const modeDefinition = modes[mode];
    return {
      Primary: modeDefinition.metrics?.Primary || DefaultPrimaryMetric,
      Secondary: modeDefinition.metrics?.Secondary || DefaultSecondaryMetric,
    };
  }, [mode]);
}
